var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-medical-clearance.6d738d4f.png","uri@2x": __webpack_public_path__ + "icon-medical-clearance.5f74ddad.png","uri@3x": __webpack_public_path__ + "icon-medical-clearance.3ed69f3b.png",
    width: 29,
    height: 36
});